import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {QuestionGroupModel} from '@/libs/Api';
import {QuestionGroupsDataService} from '@/libs/question-groups/question-groups-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const questionGroupsStore = registerCrudStore<QuestionGroupModel, QuestionGroupModel>(BusinessModule.QuestionGroup, new QuestionGroupsDataService());
